export default __webpack_public_path__ + "static/3-a63c4663f97ad076aaa23792cadfedf4.jpg";